import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import { EventModel } from '../../../models/event.model';
import { environment } from '../../../../environments/environment';
import { AlertService } from 'src/app/services/alert.service';
import { OrderService } from 'src/app/services/order.service';
declare let seatsio: any;

@Component({
  selector: 'app-seatsio',
  templateUrl: './seatsio.component.html',
  styleUrls: ['./seatsio.component.scss'],
})
export class SeatsioComponent implements OnInit {
  @Input() event!: EventModel | undefined;

  @Output() selectedSeats: EventEmitter<any> = new EventEmitter();

  @Output() deselectedSeats: EventEmitter<any> = new EventEmitter();

  @Output() sendLoadingSeatsIo: EventEmitter<any> = new EventEmitter();

  public config!: any;
  public blockFullTickets = ["10fab674-9b56-4fec-9c5f-cbd48067e05d", "f170acf1-57c9-4ecb-8f64-91d4ec669272", "2c35cd19-7fe5-4444-a1ab-9f34a2730a6e", "ad900232-9f77-4805-90ef-6e1275009213", "8632884b-10f0-4530-962f-7f4f1210bbab", "c0c1e338-161e-49b0-8437-c1f1544cfbcd"]
  private prices: Array<any> = [];

  @ViewChild('chart', { static: true }) chart!: any;

  constructor(private alertService: AlertService, private orderService: OrderService) { }

  ngOnInit(): void {
    this.loadScript()
      .then(() => {
        this.renderChart();
      })
      .catch((error) => {
        this.alertService.toast({
          icon: 'error',
          title: 'Erro',
          text: error.message,
        });
      });
  }

  loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn-sa.seatsio.net/chart.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () =>
        reject(new Error('Erro ao carregar o script do Seats.io'));
      document.body.appendChild(script);
    });
  }

  getMaxSelectedObjectsOptions(): Array<{ category: string, quantity: number }> {
    return this.event!.sectors!.map((sector: any) => {
      return { category: sector.id, quantity: sector.limitByCPF || 99999 };
    }) || [];
  }

  /*
    inicia seatsio com os valores e tipos dos ingressos
  */
  async renderChart() {
    if (this.event !== undefined) {
      // faz loop nos setores
      this.event!.sectors!.forEach((sector: any) => {
        // verifica quais setores tem assento
        if (sector.useSeats == true) {
          // variável para salvar a categoria (id do setor) e o tipo de ticket (id, preço e nome)
          let category: any = { category: sector.id, ticketTypes: [] };
          // faz loop nos tickets
          this.event!.tickets!.sort((a: any, b: any) => a.position - b.position)!.forEach((ticket: any) => {
            // verifica se o ingresso pertence ao setor que tem assento, caso tenha irá salvar na variável category
            if (sector.id == ticket.sectorId) {
              category.ticketTypes[category.ticketTypes.length] = {
                ticketType: ticket.id,
                price: ticket.price,
                label: ticket.name,
              };
            }
          });
          // salva categoria na variável prices que será usada no setasio
          this.prices[this.prices.length] = category;
        }
      });

      this.orderService.removeSeatsIoTickets();

      this.chart = await new seatsio.SeatingChart({
        divId: 'chart',
        region: 'sa',
        workspaceKey: environment.seatsioWorkspaceKey,
        event: this.event!.seatsioEventKey,
        language: 'pt',
        height: '300px',
        width: '100%',
        session: 'continue',
        showSeatLabels: true,
        pricing: this.prices,
        maxSelectedObjects: this.getMaxSelectedObjectsOptions(),
        priceFormatter: (price: any) => {
          return (
            'R$ ' + price.toLocaleString('pt-br', { minimumFractionDigits: 2 })
          );
        },
        onHoldSucceeded: (object) => {
          let ticketName = ""
          this.prices.forEach(function (price) {
            price.ticketTypes.filter(function (ticket) {
              if (ticket.ticketType == object[0].selectedTicketType) {
                ticketName = ticket.label
              }
            })
          })

          if (this.blockFullTickets.indexOf(object[0].selectedTicketType) > -1) {
            this.alertService.toast({
              icon: 'error',
              title: 'Erro',
              text: 'Ingresso ' + ticketName + ' não está disponível',
            });
            object[0].deselect();
          }
        },
        onReleaseHoldFailed: function (object) {
          object[0].deselect();
        },
        onChartRenderingFailed: (chart: any) => {
          chart.destroy();
          this.sendLoading(false);
          this.alertService.toast({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao criar mapa de assentos. Para tentar novamente recarregue a página.',
          });
        },
        onRenderStarted: () => {
          this.sendLoading(true);
          // this.orderService.removeSeatsIoTickets();
        },
        onHoldTokenExpired: () => {
          // this.orderService.removeSeatsIoTickets();
        },
        onChartRendered: (chart: any) => {
          this.sendLoading(false);
          //  this.chart.chart.clearSelection();
          // this.orderService.removeSeatsIoTickets();
        },
        // ao selecionar um assento, irá chamar uma função que irá guardar o assento selecionado e o preço
        onObjectSelected: (re: any) => {
          if (this.chart.selectedSeats.length > this.event!.limitCPF!) {
            this.alertService.toast({
              icon: 'error',
              title: 'Erro',
              text: 'Você já atingiu o limite de ingressos para este evento.',
            });
            re.deselect();

            return;
          }

          re.pricing.ticketTypes.forEach((element: any) => {
            if (element.ticketType == re.selectedTicketType) {
              this.getSelectedObjects(re);
            }
          });
        },

        // ao deselecionar um assento, irá chamar uma funcção que irá remover o assento selecionado pelo id do assento
        onObjectDeselected: (re: any) => {
          // this.chart.chart.listSelectedObjects().then((re: any) => {
          //   if (re.length == 0) {
          //     this.orderService.removeSeatsIoTickets();
          //   }
          // });
          this.getDeselectedObjects(re);
        },
      }).render();
    }
  }

  /*
    pega os objetos selecionados e os manda para o componente pai
  */
  getSelectedObjects(selectedSeat: any) {
    this.event!.tickets!.forEach((ticket: any) => {
      // verifica se o ticket bate com o ticket selecionado e manda as informações do assento e do ticket para componete pai
      if (ticket.id == selectedSeat.selectedTicketType) {
        let emit: any = { ticket, selectedSeat };
        this.selectedSeats.emit(emit);
      }
    });
  }

  sendLoading(loading: boolean) {
    this.sendLoadingSeatsIo.emit(loading);
  }

  /*
    pega o id do assento deselecionado e o manda para o componente pai para ser removido
  */
  getDeselectedObjects(deselectedSeat: string) {
    this.deselectedSeats.emit(deselectedSeat);
  }
}
